import type { AllRouteEndpoints } from "../routeTypes";
export const appsConnectedContentCredentialCreateCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/connected_content_credentials",
];
